export const levels = [
    {
        id: "aboutMe",
        cards: [
            { src: "../assets/images/cards/aboutMeCard.png", data: "aboutMe" },
        ],
        dialogs: [
            { text: "*Finding the perfect candidate... a quest as elusive as a shadow in the fog.*", speaker: "" },
            { text: "*Countless résumés with lifeless templates, countless GitHub pages, echoing the same tired lines none held what you sought.*", speaker: "" },
            { text: "*But whispers reached your ears... of a seer who sees beyond the veil, who finds those hidden by fate itself.*", speaker: "" },
            { text: "*And so, with hope flickering like a dying flame, you knocked on her door.*", speaker: "" },
            { text: "*This is the day... your search ends.*", speaker: "" },
            { text: "Hi... I'm looking for someone.", speaker: "You:" },
            { text: "The threads of fate are many... but tell me, seeker what kind of person does your heart and company truly need?", speaker: "Seer:" },
            { text: "I’m looking for someone trustworthy and hard-working, a fast learner who works well with others.", speaker: "You:" },
            { text: "They should have solid programming skills, along with knowledge and experience of networking and software design and development.", speaker: "You:" },
            { text: "Hmm... a rare combination indeed. But the cosmos may yet align in your favor...", speaker: "Seer:" },
            { text: "*The seer reaches for an old, weathered deck. With her eyes closed and a barely audible whisper, she throws two cards onto the table*" , speaker: "" },
            { text: "Go ahead.", speaker: "Seer:" },
        ]
    },
    {
        id: "studies",
        cards: [
            { src: "./assets/images/cards/redesCard.png", data: "IT" },
            { src: "./assets/images/cards/bachelorCard.png", data: "bachelor" },
            { src: "./assets/images/cards/masterCard.png", data: "master" },
        ],
        dialogs: [
            { text: "*As you flip the cards, you feel a foreign pulse throbbing beneath your fingers.*", speaker: "" },
            { text: "WOW! What was that?!", speaker: "You:" },
            { text: "That heartbeat... was the imprint of the soul you're seeking.", speaker: "Seer:" },
            { text: "But... how can I have memories of this Miguel if I've never met him?!", speaker: "You:" },
            { text: "Your destinies are already entwined... he is the one you seek.", speaker: "Seer:" },
            { text: "That's for me to decide. Well then, can you show me more?", speaker: "You:" },
            { text: "His academic background, for example?", speaker: "You:" },
            { text: "*The seer begins dealing cards onto the table.*", speaker: "" }
        ]
    },
    {
        id: "experience",
        cards: [
            { src: "./assets/images/cards/iislafeCard.png", data: "iislafe" },
            { src: "./assets/images/cards/mindCard.png", data: "mindTrips" },
            { src: "./assets/images/cards/canteraCard.png", data: "cantera" },
            { src: "./assets/images/cards/ownCard.png", data: "OWN" },
            { src: "./assets/images/cards/aemeCard.png", data: "aeme" },
            { src: "./assets/images/cards/hechiceriaCard.png", data: "hechiceria" },
        ],
        dialogs: [
            { text: "His knowledge runs deep... but true power lies in how he wielded it.", speaker: "Seer:" },
            { text: "Do you mean his professional experience?", speaker: "You:" },
            { text: "There are gaps between his studies... could he have worked during that time?", speaker: "You:" },
            { text: "*The seer's nails trail across the cards, leaving a glowing trace*", speaker: "" },
            { text: "The paths of destiny are rarely linear, recruiter...", speaker: "Seer:" },
            { text: "Those 'gaps' in his path hold what no diploma can display.", speaker: "Seer:" },
            { text: "But this I will tell you: during that time, his soul devoured every scrap of knowledge it found.", speaker: "Seer:" },
            { text: "Rarely have I seen such a voracious fire... such hunger to grow.", speaker: "Seer:" },
            { text: "Please... show me that part of his story.", speaker: "You:" },
            { text: "Prepare yourself... what you'll see aren't mere jobs, but the trials that forged his mettle.", speaker: "Seer:" }
        ]
    },
    {
        id: "skills",
        cards: [
            { src: "./assets/images/cards/unityCard.png", data: "unity" },
            { src: "./assets/images/cards/unrealCard.png", data: "ue" },
            { src: "./assets/images/cards/reactCard.png", data: "react" },
            { src: "./assets/images/cards/springCard.png", data: "spring" },
            { src: "./assets/images/cards/laravelCard.png", data: "laravel" },
            {  src: "./assets/images/cards/azureCard.png", data: "azure" },
            { src: "./assets/images/cards/codeCard.png", data: "codeLanguages" },
        ],
        dialogs: [
            { text: "Strength is forged in fire... but tools must stay razor-sharp.", speaker: "Seer:" },
            { text: "Fullstack web developer, software and game programmer, all the way to network administrator.", speaker: "You:" },
            { text: "His thirst for knowledge is... admirable. I like what I'm seeing.", speaker: "You:" },
            { text: "With these years of experience and education, he must possess exceptional skills.", speaker: "You:" },
            { text: "Tools that materialize what only he can envision.", speaker: "Seer:" },
            { text: "Weapons that shatter boundaries between thought and creation.", speaker: "Seer:" },
            { text: "Let's see how sharp they are.", speaker: "Seer:" }
        ]
    },
    {
        id: "projects",
        cards: [
            { src: "./assets/images/cards/thumusCard.png", data: "thumus" },
            { src: "./assets/images/cards/candyCard.png", data: "candy" },
            { src: "./assets/images/cards/sh2Card.png", data: "sh2" },
            { src: "./assets/images/cards/tfgCard.png", data: "tfg" },
            { src: "./assets/images/cards/tfmCard.png", data: "tfm" },
        ],
        dialogs: [
            { text: "The tools are sharpened... but true art lies in their application.", speaker: "Seer:" },
            { text: "His skills are astonishing! He masters multiple code languages, modern frameworks and game engines!", speaker: "You:" },
            { text: "The technical knowledge is impressive... but tell me, recruiter...", speaker: "Seer:" },
            { text: "What good is a perfect weapon without works to demonstrate its power?", speaker: "Seer:" },
            { text: "His soul has revealed what he knows... now we shall behold what he's forged.", speaker: "Seer:" }
        ]
    },
    {
        id: "contact",
        cards: [
            { src: "./assets/images/cards/twitterCard.png", data: "twitter" },
            { src: "./assets/images/cards/githubCard.png", data: "github" },
            { src: "./assets/images/cards/linkedinCard.png", data: "linkedin" },
            { src: "./assets/images/cards/itchioCard.png", data: "itchio" },
            { src: "./assets/images/cards/emailCard.png", data: "email" },
        ],
        dialogs: [
            { text: "I must admit... when I first walked in here, I thought you were a fraud.", speaker: "You:" },
            { text: "But after this experience... I see it was all true.", speaker: "You:" },
            { text: "You've found the perfect candidate for our company.", speaker: "You:" },
            { text: "*The candle flames flicker blue as the seer smiles knowingly*", speaker: "" },
            { text: "The threads of fate never lie, recruiter.", speaker: "Seer:" },
            { text: "They merely revealed what your heart already knew.", speaker: "Seer:" },
            { text: "*The seer throw cards across the table one final time*", speaker: "" },
            { text: "Miguel has played his part... now the next move is yours to make.", speaker: "Seer:" }
        ]
    }
];